import './aopsCommonModal.scss'
const ModalStatusButtonGroup = ({
  options,
  value,
  onChange,
  isRound = false,
  disabled = false,
  readOnly = false,
  disabledOptions = [],
  onClickDisabled = () => {},
  isMultiple = false,
}) => (
  <div className="status-button-group">
    {options.map((item) => {
      // console.log('item', item)
      const isObject = typeof item === 'object'
      const label = isObject ? item.label : item
      const itemId = isObject ? (item.id ?? item.label) : item
      const isActive = isMultiple ? value.includes(itemId) : value === itemId
      const isDisabled = disabledOptions.includes(label) || disabled
      return (
        <button
          key={label}
          type="button"
          className={`status-tag ${isRound ? 'round' : ''} ${isActive ? 'active' : ''} ${isDisabled ? 'disabled' : ''} ${readOnly ? 'read-only' : ''}`}
          onClick={() => {
            if (isDisabled) {
              onClickDisabled()
            } else {
              onChange(itemId)
            }
          }}
          disabled={disabled}
        >
          {/* 도트 정보가 있을 때만 렌더링 */}
          {!isRound && isObject && item.color && (
            <span className="dot" style={{ backgroundColor: item.color }} />
          )}
          {label}
        </button>
      )
    })}
  </div>
)

export default ModalStatusButtonGroup
